/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import React, { FunctionComponent, useEffect } from 'react';
import { NetworkManager } from '../../core/network/NetworkManager';
import { DeviceModel } from '../../core/device';

const NetworkChangeEvents: FunctionComponent = (): JSX.Element => {
    const handleMessageEvent = (event) => {
        const data = event?.data;
        if (data.type !== NetworkManager.SERVICE_NAME) {
            return;
        }

        NetworkManager.onChange(data.response.status);
    };

    useEffect(() => {
        window.addEventListener('message', handleMessageEvent);

        return () => {
            window.removeEventListener('message', handleMessageEvent);
        };
    }, []);

    // This is only for browser support as we don't get the network status from Shell App.
    const handleOnlineEvent = () => {
        if (!DeviceModel.inFrame())
            NetworkManager.onChange(NetworkManager.NetworkState.INTERNET_CONNECTED);
    };

    const handleOfflineEvent = () => {
        if (!DeviceModel.inFrame())
            NetworkManager.onChange(NetworkManager.NetworkState.INTERNET_DISCONNECTED);
    };

    useEffect(() => {
        window.addEventListener('online', handleOnlineEvent);
        window.addEventListener('offline', handleOfflineEvent);
        return () => {
            window.removeEventListener('online', handleOnlineEvent);
            window.removeEventListener('offline', handleOfflineEvent);
        };
    }, []);

    return <></>;
};

export default NetworkChangeEvents;
